export function isInvalidUsername(username, usernameRestrictRegex) {
    const usernameRestrictRegexToString = `^${usernameRestrictRegex}$`;
    if (!username.match(usernameRestrictRegexToString) || username.includes(" ")) {
        return true;
    }
    return false;
};